import * as http from '@/api/config';

export function applyImgCode() {
    const url = 'user/home/v1/user/imgCode';
    return http.$get(url);
}

/* 账户登录 */
export function loginAdminByAccount(data) {
	const url = 'user/admin/v1/login/account';
	return http.$post(url, data);
}
/* 获取扫码用编码 */
export function getLoginScanCode() {
    const url = 'user/admin/v1/login/get_scan';
    return http.$get(url);
}
/* 获取扫码状态 */
export function checkLoginScanStatus(code) {
    const url = 'user/admin/v1/login/check_scan/' + code;
    return http.$get(url);
}
/* 微信小程序登录 */
export function loginAdminByWechat(data) {
	const url = 'user/admin/v1/login/wechat';
	return http.$post(url, data);
}
/* 钉钉登录网页 */
export function loginAdminByDing(code) {
    const url = 'user/admin/v1/login/ding';
    return http.$post(url, {
        platform: 'web',
        code: code,
    });
}
/* 获取用户信息 */
export function getMineInfo() {
    const url = 'user/admin/v1/user/mine';
    return http.$get(url);
}
/* 绑定钉钉账号 */
export function bindDingAccount(code) {
    const url = 'user/admin/v1/user/bindDing';
    return http.$post(url, {
        platform: 'web',
        code: code,
    });
}
/* 修改用户信息 */
export function updateUserMessage(data) {
    const url = 'user/admin/v1/user/update';
    return http.$put(url, {
        scene: 'info',
        value: data,
    });
}
/* 获取通知 */
export function getNotice(data) {
    const url = 'user/home/v1/user/notice';
    return http.$get(url, data);
}



// WEBPACK FOOTER //
// ./src/api/module/user.js